export { default as TemplateSolidIcon } from './TemplateSolidIcon';
